module.exports = __webpack_public_path__ + "img/sql.c1b45a1a.svg";